import logEvent from 'analytics/logEvent';
import React from 'react';

import pagesUrls from 'constants/pagesUrls';

import ALink from 'components/basic/ALink';
import Icon, { IconTypes } from 'components/basic/Icon';
import { BodyL } from 'components/basic/Typography';

import s from './error.module.scss';

interface Props {
  eventName: string;
}

export default function LinkList({ eventName }: Props): JSX.Element {
  return (
    <div className={s.linkListWrapper}>
      <div className={s.linkListItem}>
        <ALink
          className={s.linkListLink}
          href={pagesUrls.plans}
          onClick={(): void => {
            logEvent(eventName, {
              link_id: 'membership_plans',
            });
          }}
        >
          <Icon icon={IconTypes.pro} size={24} color="yellow" />
          <BodyL className={s.linkText}>Membership plans</BodyL>
          <Icon
            icon={IconTypes.arrowRight}
            size={24}
            color="white"
            className={s.arrowRight}
          />
        </ALink>
      </div>
      <div className={s.linkListItem}>
        <ALink
          className={s.linkListLink}
          href="/lms/courses/12/452"
          onClick={(): void => {
            logEvent(eventName, {
              link_id: 'science',
            });
          }}
        >
          <Icon icon={IconTypes.science} size={24} color="yellow" />
          <BodyL className={s.linkText}>The science of living well</BodyL>
          <Icon
            icon={IconTypes.arrowRight}
            size={24}
            color="white"
            className={s.arrowRight}
          />
        </ALink>
      </div>
      <div className={s.linkListItem}>
        <ALink
          className={s.linkListLink}
          href="https://welltory.com/team/"
          onClick={(): void => {
            logEvent(eventName, {
              link_id: 'team',
            });
          }}
        >
          <Icon icon={IconTypes.heart} size={24} color="brand" />
          <BodyL className={s.linkText}>More about Welltory</BodyL>
          <Icon
            icon={IconTypes.arrowRight}
            size={24}
            color="white"
            className={s.arrowRight}
          />
        </ALink>
      </div>
    </div>
  );
}
